module.exports = __webpack_public_path__ + "static/media/66.cab5543e.webp";